import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Icon } from '@node-space/ui-components'

export interface EarnCustomerRewardsProgramProps {
  totalBalance: string
  retainedEarningsPercentage: string
  onDistributeEarningsClick: () => void
}

export const EarnCustomerRewardsProgram = ({
  totalBalance,
  retainedEarningsPercentage,
  onDistributeEarningsClick,
}: EarnCustomerRewardsProgramProps) => {
  const { t } = useTranslation()

  return (
    <Box
      className="rounded-[12px] overflow-hidden border border-stroke-static"
      testId="earn-customer-rewards-program"
    >
      <Box flexCol gap={16} className="bg-surface-static px-6 py-4">
        <h4 className="text-h4 text-foreground-prominent">
          {t('earn.customerRewardsProgramTitle')}
        </h4>

        <Box flexCol gap={4}>
          <p className="text-label text-foreground-prominent">
            {t('earn.totalBalanceAcrossCustomers')}
          </p>
          <h3 className="text-h3 text-foreground-prominent">{totalBalance}</h3>
        </Box>

        <Box flexCol gap={4}>
          <p className="text-body-strong-small text-foreground-subdued">
            {t('earn.retainedCustomerEarningsPercentage')}
          </p>
          <h3 className="text-h3 text-foreground-prominent">{retainedEarningsPercentage}</h3>
        </Box>
      </Box>

      <button
        type="button"
        onClick={onDistributeEarningsClick}
        className="flex w-full items-center justify-center gap-1 border-t border-stroke-static bg-surface-interactive px-6 py-4 text-foreground-action-secondary"
      >
        <p className="text-label flex-1 text-left">
          <span className="text-foreground-prominent">
            {t('earn.retainedEarningsDescription', {
              percentage: retainedEarningsPercentage,
            })}{' '}
          </span>
          <span className="hover:underline">{t('earn.distributeEarningsToCustomers')}</span>
        </p>
        <Icon name="ArrowRight" size="medium" />
      </button>
    </Box>
  )
}
